<div class="scholarship-settings">
  <h2> Ustawienia dofinansowań</h2>
  <div *ngIf="!isLoading" class="row">
    <mat-card class="scholarship-settings__card">
      <h4> Osoby potrzebne do zaakceptowania stypendium</h4>
      <mat-slider [(ngModel)]="scholarshipSettings.neededToAccept" class="scholarship-settings__slider" max="10" min="1" step="1"
                  thumbLabel="true">
      </mat-slider>
    </mat-card>
    <mat-card class="scholarship-settings__card">
      <h4> Osoby potrzebne do odrzucenia stypendium</h4>
      <mat-slider [(ngModel)]="scholarshipSettings.neededToDecline" class="scholarship-settings__slider" max="10" min="1" step="1"
                  thumbLabel="true">
      </mat-slider>
    </mat-card>
  </div>
  <div *ngIf="isLoading" class="loading">
    <mat-spinner></mat-spinner>
  </div>
  <div class="row">
    <button (click)="onFormSubmit()" color="primary" mat-raised-button> Zapisz</button>
  </div>
</div>
